export const AppStatsQueryDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'appStatsQuery' },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'viewer' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'bannerProperty' },
                                    arguments: [
                                        {
                                            kind: 'Argument',
                                            name: { kind: 'Name', value: 'propertyName' },
                                            value: {
                                                kind: 'EnumValue',
                                                value: 'DISPLAY_INSIGHTS_BANNER',
                                            },
                                        },
                                    ],
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                                        ],
                                    },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'appStats' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'unreadChats' },
                                            },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'activities' },
                                            },
                                            { kind: 'Field', name: { kind: 'Name', value: 'jobs' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'news' } },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'contactRequests' },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'probusinessNotifications',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'notificationCenterWeb' },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'notificationCenterWebVisionType',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'premiumPerksNew' },
                                            },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'networkHome' },
                                            },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'resonanceHub' },
                                            },
                                            { kind: 'Field', name: { kind: 'Name', value: 'meHub' } },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'unseenMessages' },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
};
//# sourceMappingURL=appStatsQuery.gql-types.js.map